import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Badge } from "../components/ui/badge";

export default function Buyers() {
  const [data, setData] = useState(null);
  useEffect(() => { api.sources().then(setData).catch(console.error); }, []);
  if (!data) return <div className="p-8 text-zinc-500">Loading…</div>;

  return (
    <div className="p-8" data-testid="buyers-page">
      <div className="mb-6">
        <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-mono mb-1">Priority Buyers</div>
        <h1 className="text-3xl font-bold font-[Chivo] tracking-tight">Prioritised Canadian buyers</h1>
        <p className="text-sm text-zinc-600 mt-2 max-w-2xl">
          Initial list of Canadian municipalities, school boards, housing authorities,
          universities and cooperative procurement organisations targeted for HR /
          payroll / ERP / Oracle opportunities. Used by the enrichment module to
          add employee size, student count and housing units to each opportunity.
        </p>
      </div>
      <div className="border border-zinc-200 bg-white">
        <table className="w-full text-sm" data-testid="buyers-table">
          <thead className="bg-zinc-50">
            <tr className="text-[10px] uppercase tracking-widest text-zinc-500 font-mono">
              <th className="text-left px-4 py-2">Buyer</th>
              <th className="text-left px-3 py-2">Type</th>
              <th className="text-left px-3 py-2">Prov</th>
              <th className="text-right px-3 py-2">Employees</th>
              <th className="text-right px-3 py-2">Students</th>
              <th className="text-right px-3 py-2">Housing</th>
              <th className="text-left px-3 py-2">Platforms</th>
            </tr>
          </thead>
          <tbody>
            {data.priority_buyers.map((b, i) => (
              <tr key={i} className="border-b border-zinc-100 hover:bg-zinc-50" data-testid={`buyer-row-${i}`}>
                <td className="px-4 py-3 align-top">
                  <div className="font-medium text-zinc-900">{b.name}</div>
                  {b.procurement_url && (
                    <a href={b.procurement_url} target="_blank" rel="noreferrer"
                       className="text-[11px] text-[#002FA7] hover:underline">{b.procurement_url}</a>
                  )}
                </td>
                <td className="px-3 py-3 align-top text-xs">{b.buyer_type}</td>
                <td className="px-3 py-3 align-top font-mono text-xs">{b.province}</td>
                <td className="px-3 py-3 align-top text-right font-mono text-xs">{b.employee_size?.toLocaleString() || "—"}</td>
                <td className="px-3 py-3 align-top text-right font-mono text-xs">{b.student_count?.toLocaleString() || "—"}</td>
                <td className="px-3 py-3 align-top text-right font-mono text-xs">{b.housing_units?.toLocaleString() || "—"}</td>
                <td className="px-3 py-3 align-top">
                  <div className="flex flex-wrap gap-1">
                    {(b.platforms || []).map(p => (
                      <Badge key={p} variant="outline" className="rounded-sm text-[10px] font-mono border-zinc-300">{p}</Badge>
                    ))}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
